var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18457_12034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5 27.9999H65.5V15.3333C65.5 12.6666 63.5 10.3333 60.5 10.3333H8.5C5.83333 10.3333 3.5 12.6666 3.5 15.3333V47.9999C3.5 50.6666 5.83333 52.9999 8.5 52.9999H14.5V65.6666C14.5 68.3333 16.8333 70.6666 19.5 70.6666H71.5C74.1667 70.6666 76.5 68.3333 76.5 65.6666V32.9999C76.5 29.9999 74.1667 27.9999 71.5 27.9999ZM71.5 31.6666C72.1667 31.6666 72.8333 32.3333 72.8333 32.9999V37.9999H18.1667V37.6666C18.1667 35.9999 18.1667 34.9999 18.1667 32.6666C18.1667 31.9999 18.8333 31.6666 19.5 31.6666H65.8333H71.5ZM8.5 13.9999H60.5C61.1667 13.9999 61.8333 14.6666 61.8333 15.3333V20.3333H7.16667V15.3333C7.16667 14.6666 7.83333 13.9999 8.5 13.9999ZM8.5 49.3333C7.83333 49.3333 7.16667 48.6666 7.16667 47.9999V23.9999H61.8333V27.6666H19.5H18.5C16.1667 27.9999 14.5 30.3333 14.5 32.3333C14.5 32.6666 14.5 32.6666 14.5 32.9999V37.6666C14.5 39.3333 14.5 41.3332 14.5 44.9999V49.6666H8.5V49.3333ZM71.5 66.9999H19.5C18.8333 66.9999 18.1667 66.3333 18.1667 65.6666V52.9999V44.6666V41.3333H72.8333V65.3333C72.8333 66.3333 72.1667 66.9999 71.5 66.9999Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8333 57.3333H45.1667C44.1667 57.3333 43.5 57.9999 43.5 58.9999C43.5 59.9999 44.1667 60.6666 45.1667 60.6666H59.8333C60.8333 60.6666 61.5 59.9999 61.5 58.9999C61.5 57.9999 60.8333 57.3333 59.8333 57.3333Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 51.6665H45.1667C44.1667 51.6665 43.5 52.3332 43.5 53.3332C43.5 54.3332 44.1667 54.9998 45.1667 54.9998H67.5C68.5 54.9998 69.1667 54.3332 69.1667 53.3332C69.1667 52.3332 68.5 51.6665 67.5 51.6665Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8333 52.3333H25.1667C23.8333 52.3333 22.5 53.3332 22.5 54.9999V58.3332C22.5 59.6666 23.5 60.9999 25.1667 60.9999H36.1667C37.5 60.9999 38.8333 59.9999 38.8333 58.3332V54.9999C38.5 53.3332 37.1667 52.3333 35.8333 52.3333Z",
    fill: "#C84B31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18457_12034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 60.3333,
    fill: "white",
    transform: "translate(3.5 10.3333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCard);
export default __webpack_public_path__ + "static/media/multi-card.c11ff3e19730e92f413028b82c992758.svg";
export { ForwardRef as ReactComponent };